import React, {useState} from 'react';
import {connect} from 'react-redux';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import css from './Shortcuts.module.css';
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router";
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import PersonIcon from '@material-ui/icons/Person';
import PeopleIcon from '@material-ui/icons/People';
import ExploreIcon from '@material-ui/icons/Explore';
import GridOnIcon from '@material-ui/icons/GridOn';
import EditIcon from '@material-ui/icons/Edit';
import {useMediaQuery, useTheme} from "@material-ui/core";
import EditPreset from "./EditPreset";


const Shortcuts = (props) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [editPreset, setEditPreset] = useState(null);
	const history = useHistory();

	const theme = useTheme();
	const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		setAnchorEl(null);
		history.push(e.currentTarget.dataset.path);
	};

	if( !props.presets )
		return null;

	const currentPreset = props.presets.find(preset => preset.path === history.location.pathname);
	let buttonText =  currentPreset ? currentPreset.name : 'Live';
	if( isSmall )
		buttonText = <BookmarksIcon />;

	const dialog = editPreset ? <EditPreset preset={editPreset} onClose={() => {setEditPreset(null); setAnchorEl(null);}} /> : null;

	const onClickEditPreset = (event, preset) => {
		setEditPreset(preset);
		event.stopPropagation();
		event.preventDefault();
	};

	return (<>
		{dialog}
		<div className={css.Shortcuts}>
			<Button className={css.Button} onClick={handleClick}>{buttonText}</Button>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{props.presets.map(preset => (
					<MenuItem key={'preset-' + preset.path} className={css.MenuItem} data-path={preset.path} onClick={handleClose}>
						{preset.is_custom === 1 && <PersonIcon />}
						{preset.is_custom === 0 && <PeopleIcon />}
						{preset.name === 'Nests' && !preset.is_custom && <ExploreIcon />}
						{preset.name === 'S2' && !preset.is_custom && <GridOnIcon />}
						<span className={css.PresetName}>{preset.name}</span>

						{preset.is_custom === 1 && <EditIcon className={css.EditPresetIcon} onClick={(event) => onClickEditPreset(event, preset)} />}
					</MenuItem>
				))}
			</Menu>
		</div>
	</>);
};

const mapStateToProps = (state) => {
	return {
		presets: state.core.presets
	};
};

const mapDispatchToProps = (state) => {
	return {
		//	NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Shortcuts);